import React from 'react';
import PropTypes from 'prop-types';
import PropertyCompared from './PropertyCompared';
import Button from './Button';
import Icon from './Icon';
import {str2class} from '../lib/utils';
import styled from 'styled-components';

const StyledComparison = styled.div`
  width: calc(100% - 32px);
  max-width: 730px;
  height: auto;
  position: absolute;
  top: 170px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 8;
  height: calc(100% - 160px);
  > div {
    text-align: left;
    > span {
      letter-spacing: 1px;
    }
    &:first-child {
      h2 {
        font-family:'Helvetica Neue LT W01_35 Thin';
        font-size: 1.25em;
        display: inline-block;
        > i {
          margin-right: 0.5em;
          width: 18px;
          height: 18px;
          top: 2px;
          > svg {
            width: 18px;
            height: 18px;
          }
        }
      }
      span {
        font-size: .825em;
        color: #999;
        text-transform: uppercase;
      }
      button {
        position: absolute;
        right: 20px;
        top: 20px;
        display: block;
        font-size: .825em;
        color: #000;
        i {
          margin: 2px 0 0 1em;
          width: 10px;
          height: 10px;
          float: right;
          svg {
            stroke: #000;
            stroke-width: 2;
          }
        }
        span {
          line-height: 15px;
          letter-spacing: 1px;
        }
      }
    }
    &:last-child {
      top: 60px;
      position: absolute;
      padding-bottom: 30px;
      width: 100%;
      > div {
        background-color: #fff;
        box-shadow: 0 0 10px 0 rgba(51, 51, 51, .15);
      }
    }
  }
  @media (min-width: 890px) {
    top: 120px;
  }
`;

export default function Comparison (props) {

  const {prop, data, toggleLayer, visible} = props;

  return (
    <StyledComparison visible={visible} >
      <div>
        <h2><Icon name={str2class(prop)}/>{prop} values</h2>
        <Button icon="close" label="close" transparent onClick={toggleLayer}/>
      </div>
      <div>
        {data.map((item, index) =>
          <PropertyCompared key={index} data={item}/>
        )}
      </div>
    </StyledComparison>)
}

Comparison.propTypes = {
  prop: PropTypes.string,
  data: PropTypes.array,
  visible: PropTypes.bool,
  toggleLayer: PropTypes.func
};
